import NoneChip from "../atoms/NoneChip";
import React, {useState} from "react";
import PartItem from "../atoms/PartItem";

const Part3dTab = ({ code, codeKeyData, isLoading, fetchedPartGroups, processedParts }) => {
  const { single: singleParts, grouped: groupedParts } = processedParts;
  const [collapsedItems, setCollapsedItems] = useState([]);


  return (
    <div className={"tab-content"}>
      <div className={"option"}>

        <div className={"option-list"}>
          {code === "SIGNATURE_PLATE" && <NoneChip code={code} codeKeyData={codeKeyData} />}

          <div style={{width: "100%"}}>
            {!isLoading && groupedParts.length > 0 && (
              <>
                {groupedParts.map((partItem) => {
                  const partGroupItems = fetchedPartGroups[partItem.partGroupId];

                  if (partGroupItems && partGroupItems.length > 0) {
                    return (
                      <div key={partItem.partGroupId} className={"option-group"} data-expand={!collapsedItems.includes(partItem.partGroupId)}>
                        <h2
                          // style={{paddingLeft: 0, paddingRight: 0}}
                          onClick={() => {
                            setCollapsedItems(prev =>
                              prev.includes(partItem.partGroupId)
                                ? prev.filter(item => item !== partItem.partGroupId)  // 펼침
                                : [...prev, partItem.partGroupId]                     // 접힘
                            );
                          }}
                        >
                          {partItem.nameEn}
                        </h2>
                        <div className={"option-group-expand"} data-veneer={code==="VENEER"} data-chrome-package={code==="THEME"}>
                        {
                          !collapsedItems.includes(partItem.partGroupId) &&
                          partGroupItems.map(item => {
                          const codeKey = { CODE: item.code };
                          // return <PartChip key={item.id} code={item.code} itemObject={item} codeKeyData={codeKey} />
                          return (
                            <PartItem
                              key={item.id}
                              item={item}
                              partKey={item.switchKey}
                              code={item.code}
                            />
                          );
                        })}
                        </div>
                      </div>
                    );
                  }
                  return null;
                })}
              </>
            )}
            {!isLoading && singleParts.length > 0 && (
              <div className={"option-group-expand"} data-veneer={code==="VENEER"} data-chrome-package={code==="THEME"}>
                {singleParts.map((partItem, partIndex) => {
                  const switchData = partItem.partSwitch || partItem.materialSwitch;
                  const key = switchData?.partCategory || switchData?.type;

                  return (
                    // <PartChip key={partIndex} code={code} itemObject={partItem} codeKeyData={codeKeyData} />
                    <PartItem
                      key={"PART3D_"+partItem.id}
                      item={partItem}
                      code={switchData?.code}
                      partKey={key}
                    />
                  )
                })}
              </div>
            )}
          </div>


        </div>
      </div>
    </div>
  );
};

export default Part3dTab;
